__turbopack_context__.v({
  "button": "styles-module-scss-module__b7KCva__button",
  "container": "styles-module-scss-module__b7KCva__container",
});
